(function () {

  'use strict';

  function pxNetworkGateways(
    $ngBootbox, toastr, $filter, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        network: '=context',
        meta: '=meta',
        callback: '&callback',
        me: '=me',
        isThisSiteMine: '=isThisSiteMine'
      },
      templateUrl: 'app/components/sites/networkGateways/networkGateways.template.html',
      link: function (scope) {

        scope.deleteGateway = function (gateway) {
          $ngBootbox.confirm($filter("translate")("DeleteGateway")).then(function () {
            $http.patch(scope.network._links.self.href + '?delete=true', gateway, { headers: { "Content-Type": "application/json" }}).then(function (response) {
              toastr.success($filter("translate")("GatewayDeleted"));
            }).catch(function(error){});
            scope.callback();
          }).catch(function(error){});
        };

        scope.addGateway = function (event) {
          event.stopPropagation();
          const addGatewayMeta = {
            title: "AddGateway",
            type: "addGatewayToNetwork"
          };
          scope.callback({ meta: addGatewayMeta });
        };

      }
    };
  }

  pxNetworkGateways.$inject = ['$ngBootbox', 'toastr', '$filter', '$http'];

  angular
    .module('printix-admin')
    .directive('pxNetworkGateways', pxNetworkGateways);

})();
